module.exports = __webpack_public_path__ + "images/meta/ogp/newbonuscp_ogp_2d3afa0030f5d9ba0313e802fe88f6f8.png";